import Cookies from "js-cookie";
import React from "react";
import { currencyFormat } from "../../../lib/TextFormatter";
import { useTranslation } from 'react-i18next';
import LoadingLine from "../../../shared/components/forms/LoadingLine";
import Conditional from "../../../shared/Conditional";
import Products from "../Products";
import "./OrderSummary.scss";

const OrderSummary = (props) => {
  const { t } = useTranslation("checkout")
  const { data, productTitles } = props;

  const currency = data.get("currency");
  const showDiscount = (data.get("promoCodeApplied") === true);
  let discount = `${currency} -${data.get("discount")}`;
  let taxes = `${currency} ${data.get("subtotalTaxes")}`;
  let total = `${currency} ${data.get("total")}`;
  if (data.get("isPreparing")) {
    discount = <LoadingLine key="discount-loading" />
    taxes = <LoadingLine key="taxes-loading" />
    total = <LoadingLine key="total-loading" />
  }

  // We update `products` with titles from `productTitels` if available.
  let products = data.get("products").map((product) => {
    return product.set("productTitle", productTitles.getIn([product.get("productSku"), "longTitle"], product.get("productTitle")));
  });

  return (
    <div className="OrderSummary">
      <div className="title">{t("summary.title")}</div>
      <Products
        products={products}
        subscriptionFrequencyWeeks={data.get("subscriptionFrequencyWeeks")}
      />
      <div className="content">
        <table>
          <tbody>
            <Conditional show={showDiscount}>
              <tr>
                <td>{t("summary.code_discount")}</td>
                <td>{discount}</td>
              </tr>
            </Conditional>
            <tr>
              <td>{t("summary.taxes")}</td>
              <td>{taxes}</td>
            </tr>
            <tr className="large-separator">
              <td colSpan="2"><hr/></td>
            </tr>
            <tr className="order-total">
              <td>{t("summary.total")}</td>
              <td>{total}{HACK_totalSuffix(data)}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

function HACK_totalSuffix(data) {
  try {
    const assumedCountryCode = Cookies.get("assumed_country") || "";
    const useHack = data.get("currency") === "EUR" && assumedCountryCode.toUpperCase() === "GB";

    const totalEuros = Number.parseFloat(data.get("total"));

    if (!useHack || isNaN(totalEuros)) {
      return ""; // Don't add pounds suffix
    }

    const totalProductsInPounds = HACK_sum(data.get("products"));
    if (isNaN(totalProductsInPounds)) {
      return ""; // UK user shops for non UK dispensers, e.g. for an EU address
    }

    // Add approximate taxes as well
    const euroPoundRate = 0.9; // This is a hack, huh
    const taxes = Number.parseInt(data.get("subtotalTaxes"));
    const taxesPounds = isNaN(taxes) ? 0 : taxes * euroPoundRate;

    const discount = Number.parseInt(data.get("discount"));
    const discountPounds = isNaN(discount) ? 0 : discount * euroPoundRate;

    const totalPounds = totalProductsInPounds + taxesPounds - discountPounds;
    
    return HACK_formatApproximatePriceInPounds(totalPounds);
  } catch (error) {
    return ""; // Ignore
  }
}

function HACK_sum(products) {
  // Having a subscription makes all prices subscription prices, and vice versa
  const hasSubscription = !!products.find((item) => item.get("subscription") === true);

  const amount = products.reduce(
    (acc, item) => acc + HACK_approximatePriceInPounds(item.get("productSku"), hasSubscription, item.get("quantity"))
  , 0);
  
  return amount;
}


// HACK FOR BRITISH POUNDS WITHOUT A PROPER JURISDICTION:
function HACK_approximatePriceInPounds(sku, isSubscription, quantity) {
  switch (sku) {
    case "WAT-HAL-STL-05":
      return quantity * (isSubscription ? 95 : 115);
    case "WAT-HAL-STL-8PC-750":
      return quantity * (isSubscription ? 56 : 70);
      
    case "DPR-OAS-ONX-CTP-BKS-UK":
      return quantity * 200;
    case "DPR-HAL-HDP-WBL":
      return quantity * 18;
    default:
      break;
  }
  
  return NaN;
}
function HACK_formatApproximatePriceInPounds(price) {
  return <> <span style={{whiteSpace: "nowrap"}}>{`(≈ ${currencyFormat(price, "GBP", 0, true)})`}</span></>;
}

export default OrderSummary;
